import { fmtMoney } from "../../parsers/xmlParser";

const FREQ          = { 1: "חודשי", 2: "רבעוני", 3: "חצי שנתי", 4: "שנתי", 5: "אחר" };
const INTEREST_TYPE = { 1: "קבועה", 2: "משתנה" };
const INDEXATION    = { 1: "לא צמוד", 2: "צמוד מדד חודשי", 3: "צמוד מדד חצי שנתי", 4: "אחר" };
const REPAY_TYPE    = { 1: "שפיצר", 2: "ריבית שוטפת" };

function LoanBlock({ loan: L, cs, index, showIndex }) {
  const paidPct = L.amount > 0 ? Math.min(100, Math.round((1 - L.balance / L.amount) * 100)) : 0;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, background: "#fff", padding: "12px 14px", borderRadius: 8, border: "1px solid #fce7f3", boxShadow: "0 1px 3px rgba(157, 23, 77, 0.05)" }}>
      {showIndex && (
        <div style={{ fontWeight: 700, fontSize: 13, color: "#9d174d", display: "flex", alignItems: "center", gap: 6 }}>
          <span>💰 הלוואה {index + 1}</span>
          {L.refNum && <span style={{ fontSize: 11, color: "#64748b", fontWeight: 400 }}>(אסמכתא {L.refNum})</span>}
        </div>
      )}

      {/* Summary with integrated progress */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {[
          { label: "סכום", value: fmtMoney(L.amount), color: "#9d174d", bg: "#fce7f3" },
          { label: "יתרה", value: fmtMoney(L.balance), color: "#dc2626", bg: "#fef2f2" },
        ].map((item, i) => (
          <div key={i} style={{ flex: 1, minWidth: 100, background: item.bg, borderRadius: 6, padding: "6px 10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontSize: 11, color: "#64748b" }}>{item.label}</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: item.color }}>{item.value}</span>
          </div>
        ))}
      </div>
      
      {L.amount > 0 && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: -4 }}>
          <div style={{ flex: 1, height: 6, background: "#fce7f3", borderRadius: 3, overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${paidPct}%`, background: "#9d174d" }} />
          </div>
          <span style={{ fontSize: 10, color: "#64748b", whiteSpace: "nowrap" }}>נפרע {paidPct}% ({fmtMoney(L.amount - L.balance)})</span>
        </div>
      )}

      {/* Details */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: "4px 12px", background: "#f8fafc", padding: "8px 12px", borderRadius: 6, border: "1px solid #e2e8f0" }}>
        {[
          { label: "תאריך קבלה",     value: L.startDate },
          { label: "תאריך סיום",      value: L.endDate },
          { label: "תקופה",          value: L.period > 0 ? `${L.period} חוד'` : null },
          { label: "ריבית",            value: L.interest > 0 ? `${L.interest}%` : null },
          { label: "סוג ריבית",        value: INTEREST_TYPE[L.interestType] || null },
          { label: "הצמדה",            value: INDEXATION[L.indexation] || null },
          { label: "תדירות",          value: FREQ[L.frequency] || null },
          { label: "סוג החזר",         value: REPAY_TYPE[L.repayType] || null },
          { label: "החזר תקופתי",      value: L.periodicPayment > 0 ? fmtMoney(L.periodicPayment) : null },
          { label: "רמת הלוואה",       value: L.level === "2" ? "על כל הפוליסות" : null },
        ].filter(r => r.value).map((r, i) => (
          <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", fontSize: 11 }}>
            <span style={{ color: "#64748b" }}>{r.label}:</span>
            <span style={{ fontWeight: 600, color: "#334155" }}>{r.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function LoanTab({ fund, cs }) {
  const loans = fund.loans?.length ? fund.loans : fund.loan ? [fund.loan] : [];
  if (!loans.length) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12, paddingTop: 4 }}>
      {loans.map((L, i) => (
        <LoanBlock key={i} loan={L} cs={cs} index={i} showIndex={loans.length > 1} />
      ))}
    </div>
  );
}
